import React, { FC } from 'react'
import ProjectConstants from '../../../app/utlis/projectConstants'
import classNames from 'classnames'
import images from '../../../app/utlis/image'
import { motion } from 'framer-motion'

interface AIHealthIdeaProjectProps {
  aiHealthcareData: any
}

const AIHealthIdeaProject: FC<AIHealthIdeaProjectProps> = ({ aiHealthcareData }) => {
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  }

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  }

  return (
    <motion.div 
      className='flex flex-col gap-6 sm:gap-8 md:gap-10 bg-darkGreyPrimary'
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={containerVariants}
    >
      {aiHealthcareData.AiHealthIdeaProjectsData.map((projects: any, index: number) => {
        const img = projects.image;
        return (
          <motion.div 
            key={index}
            className={`flex flex-col justify-center md:flex-${projects.row} md:flex-row px-4 sm:px-8 md:px-20 lg:px-40 gap-6 md:gap-10 mb-8 md:mb-0 md:h-96`}
            variants={itemVariants}
          >
            <motion.div 
              className={`w-full md:w-2/5 h-auto mb-4 md:mb-0 overflow-hidden`}
              variants={imageVariants}
            >
              <motion.img 
              //@ts-ignore
                src={images[img]} 
                className='w-full h-auto overflow-hidden rounded-xl md:rounded-3xl'
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              />
            </motion.div>
            <motion.div 
              className={classNames('flex flex-col w-full md:w-2/4', `flex-${projects.row} justify-start md:justify-center`)}
              variants={itemVariants}
            >
              <div className={classNames('font-semibold text-2xl sm:text-3xl md:text-4xl', `text-${projects.textColor}`)}>{projects.title}</div>
              <div className={classNames('text-greyQuaternary text-base sm:text-lg pt-2 sm:pt-3 md:pt-4', `text-${projects.text}`)}>{projects.subtitle}</div>
            </motion.div>
          </motion.div>
        )
      })}
    </motion.div>
  )
}

export default AIHealthIdeaProject
